import {
  SET_FORECASTED_REVENUE,
  SET_FORECASTED_DOE,
} from "./mutations";
import { store } from "../../index";
import ForecastedRevenue from "../../../models/valuation/ForecastedRev";
import ForecastedDOE from "../../../models/valuation/ForecastedDOE";
import { generateHDEAnalysis, generateSDEAnalysis } from "../qualityOfEarnings/actions";

//--------- generate forecasted revenue ---------//

export const generateForecastedRevenue =
  (options = { clearCache: false }) =>
  async (dispatch) => {
    await dispatch(generateHDEAnalysis());

    const { currentCompanyHDEAnalysis } = store.getState().qualityOfEarnings;
    const { forecastedRevenue } = store.getState().valuation;
    const { taxes } = store.getState();

    //get variables of currentCompanyMonthlyProfitAndLoss. They are always date descendant
    const salesRevenue = currentCompanyHDEAnalysis.totalSalesRevenue;
    const yearsFormatted = currentCompanyHDEAnalysis.yearsFormatted;

    //get growth rate
    const growthRate = Number(taxes.growthRate) / 100;

    let _forecastedRevenue;

    if (options.clearCache || !forecastedRevenue) {
      _forecastedRevenue = new ForecastedRevenue({
        yearsFormatted,
        salesRevenue,
        growthRate,
      });
    } else {
      _forecastedRevenue = new ForecastedRevenue({
        ...forecastedRevenue,
        yearsFormatted,
        salesRevenue,
        growthRate,
      });
    }

    dispatch({
      type: SET_FORECASTED_REVENUE,
      payload: _forecastedRevenue,
    });
  };


//--------- update forecasted revenue ---------//

export const updateForecastedRevenue = (type, value, date) => (dispatch) => {
  const { forecastedRevenue } = store.getState().valuation;

  //Modify changed weights in store
  if(type === "Method") forecastedRevenue.method = value;
  else if(type === "ManualValue") forecastedRevenue.manualValue = Number(value.replace(/,/g, ""));
  else if(type === "Note") forecastedRevenue.analystNote = value;
  else if(type === "Weights") {
    forecastedRevenue.weights.filter((obj) => obj.date === date)[0].value 
      = Number(value.replace(/,/g, ""));      //input is string that includes comma
  }

  dispatch({
    type: SET_FORECASTED_REVENUE,
    payload: new ForecastedRevenue({
      ...forecastedRevenue,
    }),
  });
};


//--------- generate forecasted discretionary owner earnings ---------//

export const generateForecastedDOE =
  (options = { clearCache: false }) =>
  async (dispatch) => {
    await dispatch(generateHDEAnalysis());
    await dispatch(generateSDEAnalysis());

    const { currentCompanyHDEAnalysis, currentCompanySDEAnalysis } = store.getState().qualityOfEarnings;
    const { forecastedDOE } = store.getState().valuation;
    const { taxes } = store.getState();

    //get variables of currentCompanyHDEAnalysis
    const DOE = forecastedDOE?.source === "Report"
      ? currentCompanySDEAnalysis.EBITDAOwnerSalaryAdj
      : currentCompanyHDEAnalysis.totalDiscretionaryOwnerEarnings;
    const yearsFormatted = currentCompanyHDEAnalysis.yearsFormatted;

    //get growth rate
    const growthRate = Number(taxes.growthRate) / 100;

    let _forecastedRevenue;

    if (options.clearCache || !forecastedDOE) {
      _forecastedRevenue = new ForecastedDOE({
        yearsFormatted,
        DOE,
        growthRate,
      });
    } else {
      _forecastedRevenue = new ForecastedDOE({
        ...forecastedDOE,
        yearsFormatted,
        DOE,
        growthRate,
      });
    }

    dispatch({
      type: SET_FORECASTED_DOE,
      payload: _forecastedRevenue,
    });
  };


//--------- update forecasted discretionary owner earnings ---------//

export const updateForecastedDOE = (type, value, date) => (dispatch) => {
  const { forecastedDOE } = store.getState().valuation;
  const { currentCompanyHDEAnalysis, currentCompanySDEAnalysis } = store.getState().qualityOfEarnings;

  //Modify changed weights in store
  if(type === "Source") {
    forecastedDOE.source = value;
    forecastedDOE.DOE = value === "Report"
      ? currentCompanySDEAnalysis.EBITDAOwnerSalaryAdj
      : currentCompanyHDEAnalysis.totalDiscretionaryOwnerEarnings;
  }
  if(type === "Method") forecastedDOE.method = value;
  else if(type === "ManualValue") forecastedDOE.manualValue = Number(value.replace(/,/g, ""));
  else if(type === "Note") forecastedDOE.analystNote = value;
  else if(type === "Weights") {
    forecastedDOE.weights.filter((obj) => obj.date === date)[0].value 
      = Number(value.replace(/,/g, ""));      //input is string that includes comma
  }

  dispatch({
    type: SET_FORECASTED_DOE,
    payload: new ForecastedDOE({
      ...forecastedDOE,
    }),
  });
};